<script lang="ts">

    let output : string = "";
    let input : string = "";

    function StringToHexBuf(str : string) : string
    {
        let ans : string = "";
        for(var i=0; i<str.length; i++)
        {
            let temp : number = str.charCodeAt(i);
            ans = ans.concat(temp.toString(16));
            ans = ans.concat(' ');
        }

        return ans;
    }

    function OnInputChange() : void
    {
        output = StringToHexBuf(input);
    }

</script>

<div class="columns">
    <div class="column">

        <h1 class="title" style="color:red;">ASCII text to HEX Buffer Convert</h1>

        <hr/>
        <p>Use this utility to convert an ASCII string to its HEX buffer representation. The conversion is done on the fly, 
            so copy and paste the text into the textbox to see immediate results.</p>

        <p>eg: "Hello" becomes 48 65 6c 6c 6f</p>
        <hr/>

        <div class="field">
            <label class="label">Input Text:</label>
            <div class="control">
                <textarea class="textarea" placeholder="Enter a text string" rows="5" 
                    bind:value={input} on:input={OnInputChange}
                    ></textarea>
            </div>
        </div>

        <div class="field">
            <label class="label">Output Hex Buffer:</label>
            <div class="control">
                <textarea readonly class="textarea" placeholder="Hex buffer output will appear here" rows="5">{output}</textarea>
            </div>
        </div>

    </div>
</div>

